export function htmlEncodeManipulation(s) {
  let temp = null;
  if (s !== null) {
    temp = htmlEncode2(s);
    temp = temp.replace(/[\n\r]/g, "");
    temp = temp
      .replace(/%0d/g, "")
      .replace(/%0a/g, "")
      .replace(/%0D/g, "")
      .replace(/%0A/g, "");
  }
  return temp;
}

function htmlEncode2(s) {
  return htmlEncode(s, true, false);
}
// Helper function to perform HTML encoding (since htmlEncode2 isn't available)
function htmlEncode(s, encodeSpecialChars, escapeAmper) {
  //TODO: ask s = noNull(s);
  if (!s) {
    s = "";
  }
  let str = "";

  for (let j = 0; j < s.length; j++) {
    let c = s.charAt(j);

    // encode standard ASCII characters into HTML entities where needed
    if (c < "\x80") {
      switch (c) {
        case '"':
          str += "&quot;";

          break;

        case "&":
          if (escapeAmper) {
            str += "&amp;";
          } else {
            str += "&";
          }

          break;

        case "<":
          str += "&lt;";

          break;

        case ">":
          str += "&gt;";

          break;

        default:
          str += c;
      }
    }
    // encode 'ugly' characters (ie Word "curvy" quotes etc)
    else if (encodeSpecialChars && c < "\xff") {
      let hexChars = "0123456789ABCDEF";
      let a = c % 16;
      let b = (c - a) / 16;
      let hex = "" + hexChars.charAt(b) + hexChars.charAt(a);
      str += str + "&#x" + hex + ";";
    }
    //add other characters back in - to handle charactersets
    //other than ascii
    else {
      str += str + c;
    }
  }

  return str;
}
